export default __webpack_public_path__ + "static/media/toggleon.241dfdca.svg";